import React from 'react';
import { SignUp } from '@clerk/clerk-react';

const Signup: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <SignUp routing="path" path="/sign-up" redirectUrl="/"/>
    </div>
  );
};

export default Signup;
